import { createCommands, useCommandHandler } from 'utils/commands';
import { pubSub } from 'utils/pubSub';
export const searchCommands = createCommands([
    {
        group: 'search',
        label: 'Open search input',
        name: 'openSearchInput',
        description: 'Opens the search input in the top bar',
        keyboard: { keybindings: [{ binding: [[], 'Slash'] }] },
        useRegisterHandler: () => {
            useCommandHandler({
                name: 'search:openSearchInput',
                actionFn: () => {
                    pubSub.publish('toggleGlobalSearch', { isOpen: true });
                },
            });
        },
    },
]);
